import React, { useState } from "react";

const ComboOrWinSection = ({ section }) => {
  const {
    type,
    title,
    collapseId,
    minMaxText = "Min: 100 | Max: 10k",
  } = section;
  const [isOpen, setIsOpen] = useState(true);

  const handlePrevent = (e) => e.preventDefault();
  const toggleCollapse = (e) => {
    e.preventDefault();
    setIsOpen((prev) => !prev);
  };

  if (type === "combo") {
    const { items = [], backPrice = "", backSize = "" } = section;
    return (
      <div className="market_section">
        <div>
          <p>
            <span className="mrkname">{title}</span>
            <a href="#/" className="add-pin" onClick={handlePrevent}>
              <i className="bi bi-bookmark"></i>
            </a>
            <span className="min-max">
              {" "}
              {minMaxText}{" "}
              <a
                href="#/"
                className="ms-2 game-rules-icon"
                onClick={handlePrevent}
              >
                <span>
                  <i className="bi bi-info-square-fill"></i>
                </span>
              </a>
              <button
                type="button"
                aria-expanded={isOpen}
                aria-controls={collapseId}
                aria-label="Toggle section"
                className={`an-collapse p-0 border-0 bg-transparent ${isOpen ? "" : "collapsed"}`}
                onClick={toggleCollapse}
              />
            </span>
          </p>
          <div
            className={isOpen ? "collapse show" : "collapse"}
            id={collapseId}
          >
            <div>
              <div>
                <div className="row align-items-center oddsHeader">
                  <div className="col-lg-6 col-md-5 col-8 px-0"></div>
                  <div className="col-lg-6 col-md-7 col-4 px-0">
                    <div className="btn-group">
                      <button className="ex-bl d-none d-md-block"></button>
                      <button className="ex-bl d-none d-md-block"></button>
                      <button className="back">back</button>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="row mx-0 align-items-center book_maker_type_5">
                    <div className="col-lg-6 col-md-5 col-8 px-0">
                      <span className="marketevent">
                        <ul style={{ padding: 0 }}>
                          {items.map((item, i) => (
                            <li key={i}>
                              <b>{item}</b>
                            </li>
                          ))}
                        </ul>
                      </span>
                    </div>
                    <div className="col-lg-6 col-md-7 col-4 px-0">
                      <div className="btn-group">
                        <button
                          className="back back-light d-none d-md-block"
                          style={{ visibility: "hidden" }}
                        ></button>
                        <button
                          className="back back-light d-none d-md-block"
                          style={{ visibility: "hidden" }}
                        ></button>
                        <button className="back">
                          <span>{backPrice}</span>
                          <small>{backSize}</small>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "winMatch") {
    const { options = [] } = section;
    return (
      <div className="market_section">
        <div>
          <p>
            <span className="mrkname">{title}</span>
            <a href="#/" className="add-pin" onClick={handlePrevent}>
              <i className="bi bi-bookmark"></i>
            </a>
            <span className="min-max">
              {" "}
              {minMaxText}{" "}
              <a
                href="#/"
                className="ms-2 game-rules-icon"
                onClick={handlePrevent}
              >
                <span>
                  <i className="bi bi-info-square-fill"></i>
                </span>
              </a>
              <button
                type="button"
                aria-expanded={isOpen}
                aria-controls={collapseId}
                aria-label="Toggle section"
                className={`an-collapse p-0 border-0 bg-transparent ${isOpen ? "" : "collapsed"}`}
                onClick={toggleCollapse}
              />
            </span>
          </p>
          <div
            className={isOpen ? "collapse show" : "collapse"}
            id={collapseId}
          >
            <div>
              <div className="toss_market">
                <div className="row">
                  {options.map((opt, i) => (
                    <div key={i} className="col-6">
                      <h5>{opt.name}</h5>
                      <p></p>
                      <div className="position-relative">
                        <button className="back odds-button">
                          {" "}
                          {opt.odds}{" "}
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default ComboOrWinSection;
